import { render } from "./GlossaryLink.vue?vue&type=template&id=c258f302"
import script from "./GlossaryLink.vue?vue&type=script&lang=js"
export * from "./GlossaryLink.vue?vue&type=script&lang=js"

import "./GlossaryLink.vue?vue&type=style&index=0&id=c258f302&lang=scss"
script.render = render

export default script